import { Controller } from "@hotwired/stimulus";

export default class AvatarUploaderController extends Controller {
  connect() {
    this.uploading = false;

    if (location.hash === "#avatar_activator") {
      this.uploadClicked();
    }
  }

  uploadClicked() {
    const fileInput = this.element.querySelector("#avatar-file-field");
    fileInput.click();
  }

  fileSelected() {
    const submitButton = this.element.querySelector('input[type="submit"]');
    submitButton.click();
    this.uploading = true;
  }
}
